import { useGrapeClusterReport } from '../../../../services/data/reports/hooks/useGrapeClusterReport';
import { StrictDateRange } from '../../../commonUI/DateRangeFilterSelect/types';
import {
  TableColumnDefinitions,
  useLoadTable,
} from '../../../duckDB/hooks/useLoadTable';
import { UniformityFilter } from '../components/UniformityFilter/hooks/useUniformityFilter';
import { useBerriesPerClusterFilter } from './useBerriesPerClusterFilter';

const NO_MIN_SIZE = 0;
const NO_MAX_SIZE = 50;

export const useLoadClusterReport = (
  customerId: string,
  dateRange: StrictDateRange | null,
  blockIds: string[],
  berriesPerCluster: string,
  uniformityFilter: UniformityFilter | undefined
) => {
  const berriesPerClusterFilter = useBerriesPerClusterFilter(berriesPerCluster);

  const { clusterReportData, isClusterReportLoading } = useGrapeClusterReport(
    customerId,
    blockIds,
    berriesPerClusterFilter,
    uniformityFilter
      ? {
          max_diameter_mm: uniformityFilter.maxSize || NO_MAX_SIZE,
          min_diameter_mm: uniformityFilter.minSize || NO_MIN_SIZE,
          threshold_pct: uniformityFilter.clusterConsistency,
        }
      : undefined,

    dateRange ?? undefined
  );

  const { isTableLoading } = useLoadTable(
    'cluster_report_table',
    clusterReportData,
    {
      columns: CLUSTER_REPORT_COLUMN_DEFS,
    }
  );

  return {
    isTableLoading,
    isClusterReportLoading,
  };
};

const CLUSTER_REPORT_COLUMN_DEFS: TableColumnDefinitions = {
  block_id: 'VARCHAR',
  block_name: 'VARCHAR',
  ranch_id: 'VARCHAR',
  ranch_name: 'VARCHAR',
  scan_date: 'TIMESTAMP_S',
  scan_id: 'VARCHAR',
  variety_id: 'VARCHAR',
  total_cluster_count: 'VARCHAR',
  filtered_cluster_count: 'VARCHAR',
};
